import dayjs from 'dayjs';
import '../../../node_modules/dayjs/plugin/isSameOrAfter.js';

const sortSpaces = (field, order) => {
  switch (field) {
    case "name":
      return (a, b) => {
        if (a.subtype === "inbox") return -1;
        if (b.subtype === "inbox") return 1;
        const aTitle = a.folder.name || "";
        const bTitle = b.folder.name || "";
        return aTitle.localeCompare(bTitle) * (order === "ASC" ? 1 : -1);
      };
    case "createdAt":
      return (a, b) => {
        if (a.subtype === "inbox") return -1;
        if (b.subtype === "inbox") return 1;
        return (dayjs(a.createdAt).isSameOrAfter(b.createdAt) ? 1 : -1) * (order === "ASC" ? 1 : -1);
      };
    case "modifiedAt":
    default:
      return (a, b) => {
        if (a.subtype === "inbox") return -1;
        if (b.subtype === "inbox") return 1;
        return (dayjs(a.modifiedAt).isSameOrAfter(b.modifiedAt) ? 1 : -1) * (order === "ASC" ? 1 : -1);
      };
  }
};
const filterSpaces = (roots, filters) => {
  if (!roots) return [];
  let nextData = roots;
  const { sort, keyword, privacy } = filters;
  if (privacy === "private") {
    nextData = nextData.filter((root) => {
      return !root.folder.isPublic && root.folder.memberCount === 1;
    });
  } else if (privacy === "shared") {
    nextData = nextData.filter((root) => {
      return root.folder.isPublic || root.folder.memberCount > 1;
    });
  }
  if (keyword) {
    nextData = nextData.filter((root) => {
      return (root.folder.name || "").toLowerCase().includes(keyword.trim().toLowerCase());
    });
  }
  return nextData.sort(sortSpaces(sort?.property || "modifiedAt", sort?.direction || "DESC"));
};

export { filterSpaces };
//# sourceMappingURL=filterSpaces.js.map
